import React from "react";
import Header from "../../header";
import { apiCall_domain, token } from "../../api";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
class forgetPassStep2 extends React.Component {
  state = {
    changeDetail: true,
    newPass: "",
    newPassRetry: "",
    loading: false,
    successValid: false,
  };
  componentDidMount() {
    localStorage.getItem("successValid") && this.props.history.push("/");
  }

  render() {
    const SetNewPassword = (e) => {
      this.setState({ newPass: e.target.value });
    };
    const SetNewPasswordRetry = (e) => {
      this.setState({ newPassRetry: e.target.value });
    };

    const handleSubmit = (e) => {
      this.setState({ loading: true });
      if (this.state.newPass.length > 7) {
        if (this.state.newPass === this.state.newPassRetry) {
          const Data = {
            phone: localStorage.getItem("phone"),
            code: this.props.location.state,
            password: this.state.newPass,
          };
          const headers = {
            Authorization: token(),
            "content-type": "application/json",
          };
          axios
            .post(`${apiCall_domain}/customer/auth/forget_password/s2`, Data, {
              headers: headers,
            })
            .then((res) => {
              this.props.history.push("/profile");
              localStorage.setItem("successValid", 1);
              const Headers = {
                Authorization: token(),
                "content-type": "application/json",
              };
              const Data = {
                phone: localStorage.getItem("phone"),
                password: this.state.newPass,
                dev_type: "IOS",
                gcm_id: "1",
              };
              axios
                .post(`${apiCall_domain}/customer/auth/login`, Data, {
                  headers: Headers,
                })

                .then((res) => {
                  localStorage.setItem("Api_key", res.data.api_key);
                  localStorage.removeItem("phone");
                  localStorage.removeItem("validationCode");
                  this.setState({ loading: true });
                  const url = new URL(window.location.href);
                  window.location.replace(url.origin);
                });
            })
            .catch((error) => {
              this.setState({
                error: error.response.data.message,
                errorDisplay: "error d-flex",
                loading: false,
              });
            });
        } else {
          this.setState({
            error: "فیلدها با یکدیگر مطابقت ندارند",
            errorDisplay: "error d-flex",
            loading: false,
          });
        }
      } else {
        this.setState({
          error: "رمز عبور حداقل باید 8 کاراکتر باشد",
          errorDisplay: "error d-flex",
          loading: false,
        });
      }
    };
    return (
      <>
        <div className="EnterPass">
          <Header showSearchBar={true} title={"رمز عبور "} />
          <div className="phoneBox">
            <div className="phoneTitle">رمز عبور جدید را وارد کنید</div>
            <input
              className="input newPass"
              placeholder="رمز عبور جدید"
              onChange={(e) => SetNewPassword(e)}
              type={"password"}
            ></input>
            <input
              className="input newPass2"
              placeholder="تکرار رمز عبور جدید"
              onChange={(e) => SetNewPasswordRetry(e)}
              type={"password"}
            ></input>
            <div className="error">{this.state.error}</div>
          </div>
          <div className="mySecContinue EnterCodeBtn">
            {this.state.loading ? (
              <button className="btn disabled">
                <PulseLoader size={12} color="#fff" loading={true} />
              </button>
            ) : (
              <button onClick={(e) => handleSubmit(e)}>تغییر رمز عبور</button>
            )}
          </div>
        </div>
      </>
    );
  }
}
export default forgetPassStep2;
